import { parseEventParams } from '../utils/parsingUtils';

export enum EventType {
  GameImpressions = 'gameImpressions',
  GameDetailReferral = 'gameDetailReferral'
}

export enum PageContext {
  SearchPage = 'SearchPage',
  SortDetailPage = 'SortDetailPage',
  GameDetailPage = 'GameDetailPage',
  GamesPage = 'GamesPage',
  HomePage = 'HomePage'
}

export const GameSortId = {
  Default: 0,
  Popular: 1,
  TopFavorite: 2,
  Featured: 3,
  MyFavorite: 5,
  MyRecent: 6,
  Experimental: 7,
  TopGrossing: 8,
  TopPaid: 9,
  Purchased: 10,
  TopRated: 11,
  BuildersClub: 14,
  TopRetaining: 16,
  FriendActivity: 17,
  PersonalizedByLiked: 18,
  PopularInVr: 19,
  PopularInCountry: 20,
  TrendingGames: 21,
  UnifiedGames: 22,
  Curated: 23,
  PersonalRecommendation: 24,
  MyLibrary: 25
};

type TEvent = [{ name: string; type: string; context: string }, Record<string, string | number>];

export type TGamesListGameImpressions = {
  rootPlaceIds: number[];
  absPositions: number[];
  adsPositions: number[];
  suggestionKwd: string;
  suggestionReplacedKwd?: string;
  suggestionCorrectedKwd?: string;
  suggestionAlgorithm: string;
  algorithm: string;
  sessionInfo?: string;
  emphasisFlag: boolean;
  pg: PageContext.SearchPage;
};

export type TOmniRecommendationsGameImpressions = {
  rootPlaceIds: number[];
  absPositions: number[];
  sortPos: number;
  gameSetTypeId?: number;
  gameSetTargetId?: number;
  pg: PageContext.SortDetailPage | PageContext.HomePage | PageContext.GamesPage;
};

export type TGamesListGameDetailReferral = {
  pid: number;
  ad: boolean;
  pos: number;
  tis: number;
  sessionInfo?: string;
  pg: PageContext.SearchPage;
};

export type TOmniRecommendationsTGameDetailReferral = {
  pid: number;
  ad: boolean;
  pos: number;
  gameSetTypeId?: number;
  gameSetTargetId: number;
  pg: PageContext.SortDetailPage | PageContext.HomePage | PageContext.GamesPage;
};

export type TGameImpressions = TGamesListGameImpressions | TOmniRecommendationsGameImpressions;

export type TGameDetailReferral =
  | TGamesListGameDetailReferral
  | TOmniRecommendationsTGameDetailReferral;

export default {
  gameImpressions: ({ pg, ...props }: TGameImpressions): TEvent => [
    {
      name: EventType.GameImpressions,
      type: EventType.GameImpressions,
      context: pg
    },
    parseEventParams({
      ...props,
      pg
    })
  ],
  gameDetailReferral: ({ pg, ...props }: TGameDetailReferral): TEvent => [
    {
      name: EventType.GameDetailReferral,
      type: EventType.GameDetailReferral,
      context: pg
    },
    parseEventParams({
      ...props,
      pg
    })
  ]
};
